import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';
import { convertStringToBoolean, transformToLocalize } from '../../../../../utils/CommonUtils';

class RecurringModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentRecurringCharge: {
                name: '',
                description: '',
                percentage: false,
                amount: null,
                orderType: {
                    id: -1,
                    value: 'Select type'
                },
                paymentType: { 
                    id: -1,
                    value: 'Select type'
                },
                createDate: null
            },
        };
    }

    componentDidMount() {
        if (this.props.currentRecurringCharge.name) {
            this.setState({
                ...this.state,
                currentRecurringCharge: this.props.currentRecurringCharge,
            });
        }
    }

    changeState = ({ target }) => {

        this.setState({
            currentRecurringCharge: {
                ...this.state.currentRecurringCharge,
                [target.name]: target.name === 'paymentType' || target.name === 'orderType' ? { id: parseInt(target.childNodes[target.selectedIndex].id), value: target.value }
                 : target.value
            }
        });
    }

    changeBooleanAttributeState = ({ target }) => {
        const checked = convertStringToBoolean(target.checked);

        this.setState({
            currentRecurringCharge: {
                ...this.state.currentRecurringCharge,
                [target.name]: checked
            }
        });
    }

    renderTenderTypeOptions() {
        return this.props.tenderTypes.map(type => {

            const transformToLocalize = () => {
                switch (type.value) {
                    case "Credit card":
                        return "creditCard";
                    case "Cash":
                        return "cash";
                    default:
                        return;
                }
            }

            return (
                <option key={`key${type.id}`} id={type.id} value={type.value}>{i18n.t(`common:paymentTypes.${transformToLocalize(type.value)}`)}</option>
            );
        });
    }

    renderOrderTypesOptions() {
        const { orderTypes } = this.props;
        if (orderTypes !== null && orderTypes !== undefined) {
            return this.props.orderTypes.map((orderType, i) => {

                const transformToLocalize = () => { // Transforms item.value so it can be translated.
                    switch (orderType.value) {
                        case "Collection":
                            return i18n.t('screens:restaurantsMainContainer.collection');
                        case "Delivery":
                            return i18n.t('screens:restaurantsMainContainer.delivery');
                        case "Curbside":
                            return i18n.t('screens:restaurantsMainContainer.curbside');
                        case "In Store":
                            return i18n.t('screens:restaurantsMainContainer.instore');
                        case "Dine In":
                            return i18n.t('screens:restaurantsMainContainer.dinein')
                        default:
                            return;
                    }
                }

                return <option key={`key${orderType.id}`} id={orderType.id} value={orderType.value}>{transformToLocalize(orderType.value)}</option>;
            });
        }
    }

    submitForm = () => {
        const recurringCharge = this.state.currentRecurringCharge;

        if (recurringCharge.name) {
            this.props.applyCurrentRecurringCharge(recurringCharge);
        }
    }

    renderName() {
        const { name } = this.state.currentRecurringCharge;

        return (
            <AvGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '15px', paddingRight: '15px'}}>
                <Label xs={6}>{i18n.t('screens:paymentScreen.name')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <AvInput 
                        type="text" 
                        name="name"
                        placeholder={name}
                        value={name}
                        onChange={this.changeState}
                        required
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        )
    }

    renderDescription() {
        const { description } = this.state.currentRecurringCharge;

        return (
            <AvGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '15px', paddingRight: '15px'}}>
                <Label xs={6}>{i18n.t('screens:paymentScreen.description')}</Label>
                <AvInput 
                    type="text" 
                    name="description"
                    placeholder={description}
                    value={description}
                    onChange={this.changeState}
                />
            </AvGroup>
        )
    }

    renderPercentage() {
        const { percentage } = this.state.currentRecurringCharge;

        return (
            <AvGroup xs={12} style={{ width: '100%', marginBottom: '15px', paddingRight: '15px'}}>
                <Label xs={6}>{i18n.t('screens:paymentScreen.percent')}</Label>
                <AvInput 
                    type="checkbox" 
                    name="percentage"
                    placeholder={percentage}
                    value={percentage}
                    style={{margin: '10px 0 0'}}
                    onChange={this.changeBooleanAttributeState}
                />
            </AvGroup>
        )
    }

    renderAmount() {
        const { amount } = this.state.currentRecurringCharge;

        return (
            <AvGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '15px', paddingRight: '15px'}}>
                <Label xs={6}>{i18n.t('screens:paymentScreen.amount')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <AvInput 
                        type="number" 
                        name="amount"
                        placeholder={amount}
                        value={amount}
                        onChange={this.changeState}
                        required={true}
                        onKeyPress={(e) => this.props.negativeDecimalsValidation(e)}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        )
    }

    renderOrderTypes() {
        const { orderType } = this.state.currentRecurringCharge;
        
        return (
            <AvGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '15px', paddingRight: '15px'}}>
                <Label xs={6}>{i18n.t('screens:paymentScreen.applyToOrderType')}</Label>
                <AvInput 
                    type="select" 
                    name="orderType"
                    value={orderType ? orderType.value : ''} 
                    onChange={this.changeState}>
                    <option id={-1} value=''>{i18n.t('screens:paymentScreen.selectType')}</option>
                    {this.renderOrderTypesOptions()} 
                </AvInput>
            </AvGroup>
        )
    }

    renderTenderTypes() {
        const { paymentType } = this.state.currentRecurringCharge;
        
        return (
            <AvGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '15px', paddingRight: '15px'}}>
                <Label xs={6}>{i18n.t('screens:paymentScreen.applyToPaymentType')}</Label>
                <AvInput 
                    type='select' 
                    name='paymentType'
                    onChange={this.changeState} 
                    value={paymentType ? paymentType.value : ''}>
                    <option id={-1} value=''>{i18n.t('screens:paymentScreen.selectType')}</option>
                    {this.renderTenderTypeOptions()}
                </AvInput>
            </AvGroup>
        )
    }

    renderCreatedDate() {
        const { createDate } = this.state.currentRecurringCharge;
        
        return (
            <AvGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '15px', paddingRight: '15px'}}>
                <Label xs={6}>{i18n.t('screens:paymentScreen.createDate')}</Label>
                <AvInput 
                    type="text" 
                    name="createDate"
                    placeholder={createDate}
                    value={createDate}
                    disabled
                />
            </AvGroup>
        )
    }

    renderModalBody() {
        const { createDate } = this.state.currentRecurringCharge;

        return (
            <Row style={{width: '100%'}}>
                {this.renderName()}
                {this.renderDescription()}
                {this.renderAmount()}
                {this.renderPercentage()}
                {this.renderOrderTypes()}
                {this.renderTenderTypes()}
                {
                    createDate ?
                    this.renderCreatedDate() : null
                }
            </Row>
        )
    }

    render() {
       
        return (
            <Modal className='recurringModal' isOpen={this.props.isOpen} toggle={() => this.props.toggle(true)}>
                <AvForm onValidSubmit={this.submitForm}>
                    <ModalHeader className="modalHeader" toggle={() => this.props.toggle(true)} style={{ margin: 'auto' }}>
                        {i18n.t('screens:paymentScreen.recurringCharge')}
                    </ModalHeader>
                    <ModalBody>
                        {this.renderModalBody()}
                    </ModalBody>
                    <ModalFooter>
                        { this.props.recurringChargeIndex !== -1 ?
                            <Button
                                color="primary" outline style={{ display: 'flex', alignItems: 'center' }}
                                onClick={() => this.props.applyCurrentRecurringCharge(this.state.currentRecurringCharge, true)}>
                                <span style={{ marginBottom: 1 }}>
                                    <MaterialIcon icon="delete" color="#0288D1" size={18} />
                                </span>
                                {i18n.t('common:buttons.delete')}
                            </Button> : null
                        }
                        <Button color="primary">
                            <MaterialIcon icon="check" color="#fff" size={20} />&nbsp;{i18n.t('common:buttons.apply')}
                        </Button>
                    </ModalFooter>
                </AvForm>
            </Modal>
        );
    }
}

export default RecurringModal;


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/menuuBilling/RecurringModal.js